module.exports = __webpack_public_path__ + "img/get-app-my.b4c2bcb.png";